import i from"graphql-tag";import{CircleTopicFragmentDoc as n,CircleTopicBaseFragmentDoc as u,CircleRsvpQuestionFragmentDoc as a,CircleFacilitatorFragmentDoc as s,CircleTopicSessionFragmentDoc as l}from"./fragments.generated.es.js";import*as t from"@apollo/react-hooks";const r={},c=i`
    query getFeatured {
  circleFeaturedCollection {
    totalCount
    items {
      __typename
      ... on CircleTopicNode {
        ...CircleTopic
      }
    }
  }
}
    ${n}
${u}
${a}
${s}
${l}`;function F(e){const o={...r,...e};return t.useQuery(c,o)}function C(e){const o={...r,...e};return t.useLazyQuery(c,o)}export{c as GetFeaturedDocument,C as useGetFeaturedLazyQuery,F as useGetFeaturedQuery};
//# sourceMappingURL=featured.generated.es.js.map
